import React from 'react';
import flagsmith from 'flagsmith';

const CookieBanner: React.FC = () => {
  if (!flagsmith.hasFeature('cookie_banner')) {
    return null;
  }
  return (
    <div
      style={{
        width: '100%',
        background: '#fff',
        color: '#222',
        padding: '20px 18px', // Match your main content left padding
        textAlign: 'left', // All banner content is left-aligned
        boxShadow: '0 2px 8px rgba(0,0,0,0.12)'
      }}>
      <div style={{ fontSize: 14, lineHeight: 1.6 }}>
        <strong style={{ fontSize: 17, display: 'block', marginBottom: 10 }}>Use of Cookies</strong>
        <div>This website uses cookies and similar technologies to:</div>
        <ul style={{ margin: '8px 0 0 24px' }}>
          <li>Provide core site functionality and maintenance</li>
          <li>Analyze de-identified traffic and usage patterns to improve user experience</li>
        </ul>
        <div style={{ marginTop: 12 }}>
          There is no option to disable non-essential cookies individually or as a group. By continuing, you agree to
          the use of these cookies as described above. If you do not agree to the use of cookies, please leave the
          website.
        </div>
        <div style={{ marginTop: 12 }}>
          Additional details on how cookies are used by this website are available in the linked{' '}
          <a
            href='/privacy'
            style={{ color: '#d32d27', textDecoration: 'underline', fontSize: 14 }}
            target='_blank'
            rel='noopener noreferrer'>
            Privacy Policy
          </a>
          .
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
